const initialState = {
    filters: [],
    products: [],
    productCount: 0,
};

const searchProducts = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_SEARCH':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default searchProducts;
